<template>
<div>

  <el-descriptions title="" :column="1" border label-style="width: 120px;">
    <el-descriptions-item label="成品保护表">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="成品保护表" >
        <!-- <el-link type="primary" class="el-link-common">下载模板</el-link> -->
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="其他进场表">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="其他进场表" >
        <!-- <el-link type="primary" class="el-link-common">下载模板</el-link> -->
      </FitmentFileSubgroup>
    </el-descriptions-item>
  </el-descriptions>
</div>
</template>

<script>
import FitmentFileSubgroup from "../FitmentFileSubgroup";
export default {
  name: "PreparationForEntry",
  components: {FitmentFileSubgroup},
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data(){
    return{

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/components/preparation_entry/PreparationForEntry.vue